export default {
  resource:{
    
    zh: {
      companyNo: "公司",
      companyName: "公司",
      empId:"编号",
      empNo:"工号",
      empName:"姓名",
      sex:"性别",
      sex1: "男",
      sex2: "女",
      status:"状态",
      status1: "在职",
      status2: "离职",
      deptNo:"部门",
      deptName:"部门",
      xgroup:"组别",
      duty:"职务",
      job:"岗位",
      jobTitle:"职称",
      shiftName:"班次",
      shiftNo:"班次",
      groupNo:"班组",
      groupName:"班组",
      planNo:"打卡方案",
      planName:"打卡方案",
      icNo:"IC卡号",
      birthday:"生日",
      native:"籍贯",
      marriage:"婚否",
      homeplace:"家庭地址",
      education:"学历",
      physicalDate:"体检日期",
      graduateSchool:"毕业院校",
      arriveDate:"报到日",
      arriveDate1:"报到日(开始)",
      arriveDate2:"报到日(结束)",
      contractStartDate:"合同签订日",
      contractEndDate:"合同终止日",
      political:"政治面貌",
      address:"证件地址",
      idCardNo:"证件号码",
      periodOfValidity:"证件有效期",
      residenceAddress:"户口所在地",
      nation:"民族",
      phone:"联系电话",
      consultantName:"紧急联系人",
      consultantPhone:"联系人电话",
      departureDate:"离职日",
      departureType:"离职类型",
      departureReason:"离职原因",
      isblack:"黑名单",
      socialSecurity:"社保",
      socialSecurity1: "已购买",
      socialSecurity0: "未购买",
      salaryType:"薪别",
      salaryMethod:"计薪方法",
      startAge:"入厂年龄",
      workMonth:"工龄(月)",
      age:"年龄",
      probationMonth:"试用期(月)",
      probationEndDate:"试用到期",
      stemFrom:"来源渠道",
      newOrReplace:"新增/替补",
      fingerStatus:"指纹状态",
      fingerStatus0:"未采集",
      fingerStatus1:"待上传",
      fingerStatus2:"已上传",
      faceStatus:"人脸模板状态",
      faceStatus0:"未采集",
      faceStatus1:"待下载",
      faceStatus2:"待上传",
      faceStatus3:"已上传",
      introducer:"介绍人",
      

      lzr1: "离职日(开始)",
      lzr2: "离职日(结束)",
      gr: "个人资料",
      xz: "薪别资料",
      qt: "入职资料",
      hf1: "已婚",
      hf0: "未婚",
      hf2: "离异",
      hf3: "葬偶",
      xb1: "男",
      xb2: "女",
      jn1: "在职",
      jn2: "离职",
      dw1: "辞退",
      dw2: "合同到期",
      dw3: "即辞即走",
      dw4: "开除",
      dw5: "离职",
      dw6: "正常辞工",
      dw7: "自动离厂",

      idExist: "部门序号或名称已经存在，请检查！",
      nameExist: "部门已经存在，请检查！"
    }
    

  },
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Equal",
      type: "select",
      options:"company"
    },
    rq1:{
      key: "rq",
      tkey: "arriveDate1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date",
      more: true
    },
    rq2:{
      key: "rq",
      tkey: "arriveDate2",
      data: null,
      method: "LessThanOrEqual",
      type: "date",
      more: true
    },
    lzr1:{
      key: "lzr",
      tkey: "lzr1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date",
      more: true
    },
    lzr2:{
      key: "lzr",
      tkey: "lzr2",
      data: null,
      method: "LessThanOrEqual",
      type: "date",
      more: true
    },
    empId:{
      key: "empId",
      data: null,
      method: "Equal",
      type: "text"
    },
    empName:{
      key: "empName",
      data: null,
      method: "Contains",
      type: "text"
    },
    status: {
      key: "status",
      data: "1",
      method: "Equal",
      type: "select",
      options: [{
        value: "1",
        text: "在职"
      }, {
        value: "2",
        text: "离职"
      },{
        value: "3",
        text: "黑名单"
      },]
    }
  },
  listDefine: [
    "bh", "tbjl", "xm", {key:"bdr", formatter:"fdate"}, {key:"lzr", formatter:"fdate"}, 
    "jkzk", {key:"xb", formatter:"xb"}, "ybm", "xsfzh",{key:"csrq", formatter:"fdate"}, "jbsx", "dz", "bm", "zw", "xl", "zc", 
    {key:"htqdr", formatter:"fdate"},  {key:"htzzr", formatter:"fdate"}, "dh", "zy", "bc","xingqu"
  ],
  isShowMore: true,
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  sortName: "bh",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url:"roster/",
  formatter: {
    hf(t) {
      return 'hf' + t
    },
    xb(t) {
      return 'xb' + t
    },
    jn(t) {
      return 'jn' + t
    },
    dwf(v) {
      if (v !== null) return "dw" + v
    }
  }

}
